var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateFolderPickerNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.998,
    height: 20.002
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 379",
    d: "M21.598 20h-19.2a2.456 2.456 0 01-2.4-2.5v-15a2.453 2.453 0 012.4-2.5h7.2l2.4 2h9.7a2.252 2.252 0 012.3 2.3v13.2a2.457 2.457 0 01-2.4 2.5zm-10.6-10a1 1 0 000 2h3v3a1 1 0 102 0v-3h3a1 1 0 100-2h-3V7a1 1 0 00-2 0v3z",
    fill: "#8e8e95"
  })));
}
export default SvgCreateFolderPickerNew;